import { Component, OnInit, Output, EventEmitter, Input, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, NgForm, Validators } from '@angular/forms';
import { SolarBaseComponent } from '@solar/solar/solar-base/solar-base.component';


@Component({
  selector: 'app-superv-options',
  templateUrl: './superv-options.component.html',
  styleUrls: ['./superv-options.component.scss']
})
export class SupervOptionsComponent extends SolarBaseComponent implements OnInit, OnChanges {

  supervCmp:any;
  isValidator:boolean=false;
  //issuesComponent_options: { movenext: boolean } = { movenext: false };
  constructor(
     private fb: FormBuilder
  ) {
    super();
    this.loadinglist=false;
    
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    const typeChange = changes['supervision'];
    if (typeChange && !typeChange.firstChange && typeChange.previousValue == undefined) {

    }
  }
  public static openDialog(dialog: MatDialog, model: any): MatDialogRef<SupervOptionsComponent> {
    
      let dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.width = "500px";
    

    //dialogConfig.data = { model: model, title: title, message: message, actioncaption: actioncaption }
    return dialog.open(SupervOptionsComponent, dialogConfig);

  }

  changeValue(value){
    let newValue=!value;
    return newValue;
  }

  changeIssuesOptionsValueByField(option,value){
    this.supervCmp.issuesComponent_options[option]=value;
    this.supervCmp.saveUserConfig();
  }
  changeMapOptionsValueByField(option,value){
    this.supervCmp.map_options[option]=value;
    this.supervCmp.saveUserConfig();
  }
}
